<div class="d-flex justify-content-center mb-5">
  <p-photo-editor
    [photo]="newExpert.photo"
    [isSmall]="true"
    (croppedImage)="onCroppedImage($event)"
    (clearPhoto)="onClearImage()"
  ></p-photo-editor>
</div>

<form id="informations-client-form" class="px-4" [formGroup]="expertForm">
  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.expertForm.controls.lastname"
          id="lastname"
          name="lastname"
          label="Nom"
          [tabindex]="1"
          (input)="lastnameChanged($event)"
        ></p-input>
      </div>

      <div class="mb-3">
        <p-input
          [formControl]="this.expertForm.controls.phone"
          id="phone"
          name="phone"
          label="Téléphone"
          [tabindex]="3"
          [maxLengthNumber]="20"
          errorMessage="Numéro de téléphone invalide"
          (input)="phoneChanged($event)"
        ></p-input>
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.expertForm.controls.firstname"
          id="firstname"
          name="firstname"
          label="Prénom"
          [tabindex]="2"
          (input)="firstnameChanged($event)"
        ></p-input>
      </div>

      <div class="mb-3">
        <p-input
          [formControl]="this.expertForm.controls.email"
          id="email"
          name="email"
          label="Email"
          [tabindex]="4"
          errorMessage="Adresse éléctronique invalide"
          (input)="emailChanged($event)"
        ></p-input>
      </div>
    </div>
    <div class="col-4 mb-3">
      <p-select
        id="function"
        [items]="roles?.items ?? []"
        [selectedItem]="roleItem"
        label="Fonction"
        [isCapitalize]="true"
        (selected)="onRoleChange($event)"
      ></p-select>
    </div>
    <div class="col-12">
      <div class="mb-3">
        <p-textarea
          [formControl]="this.expertForm.controls.experiences"
          id="experiences"
          name="experiences"
          [tabindex]="5"
          label="Expériences / parcours"
          [maxLength]="2500"
          [showCounter]="true"
          (input)="experiencesChanged($event)"
        ></p-textarea>
      </div>
    </div>
  </div>
</form>
